// extracted by mini-css-extract-plugin
export default {"root":"OneToMany_root__ggTqD","footer":"OneToMany_footer__sMcNi","logo":"OneToMany_logo__7Y0x0"};